module.exports = __webpack_public_path__ + "img/avatar.97ca1c5f.svg";